import { Row, Col, Card, DatePicker, Select, Button, Tooltip } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import ExportToExcel from "./ExportToExcel";

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function FiltrosDashboard({
  departamentoId,
  municipioId,
  fechaInicio,
  fechaFin,
  promotoresId,
  promotores,
  loadingPromotores,
  onSelectMunicipio,
  setPromotoresId,
  departamentos,
  municipios,
  onSelectDepto,
  setMunicipioId,
  setFechaInicio,
  setFechaFin,
  limpiarFiltros,
  loading,
  exportData,
  permissionExport,
  isAdmin,
  isRol2
}) {
  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) {
      setFechaInicio(null);
      setFechaFin(null);
    } else {
      setFechaInicio(dates[0]);
      setFechaFin(dates[1]);
    }
  };

  const formatDateDisplay = (date) => {
    if (!date) return null;
    return dayjs(date);
  };

  const tagStyle = {
    backgroundColor: '#f0f0f0',
    padding: '2px 6px',
    borderRadius: 4,
    marginRight: 6
  };

  return (
    <Card
      style={{ marginBottom: 20, borderRadius: 12 }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>Filtros de Dashboard</span>
        </div>
      }
    >
      <Row gutter={16} wrap={false} style={{ alignItems: "center" }}>
        {isAdmin && (
          <Col flex="300px">
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children ?? '')
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              value={departamentoId}
              onChange={onSelectDepto}
              placeholder="Departamentos"
              allowClear
              style={{ width: "100%" }}
              loading={loading}
              disabled={loading}
            >
              {departamentos.map((d) => (
                <Option key={d.oid} value={d.oid}>
                  {d.departamento}
                </Option>
              ))}
            </Select>

          </Col>
        )}
        {isAdmin && (
          <Col flex="300px">
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children ?? '')
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              value={municipioId}
              onChange={onSelectMunicipio}
              placeholder="Municipios"
              disabled={!departamentoId || loading}
              allowClear
              style={{ width: "100%" }}
              loading={loading}
            >
              {municipios.map((m) => (
                <Option key={m.oid} value={m.oid}>
                  {m.municipio}
                </Option>
              ))}
            </Select>
          </Col>
        )}
        {(isAdmin || isRol2) && (
          <Col flex="300px">
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children ?? '')
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              value={promotoresId}
              onChange={setPromotoresId}
              placeholder="Encuestadores"
              disabled={isAdmin ? !municipioId : false}
              allowClear
              style={{ width: "100%" }}
              loading={loadingPromotores}
            >
              {promotores.map((p) => (
                <Option key={p.oid} value={p.oid}>
                  {p.nombres} {p.apellidos}
                </Option>
              ))}
            </Select>

          </Col>
        )}
        {(isAdmin || isRol2) && (
          <Col flex="300px">
            <RangePicker
              placeholder={["Fecha inicio", "Fecha fin"]}
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              value={[
                formatDateDisplay(fechaInicio),
                formatDateDisplay(fechaFin)
              ]}
              onChange={handleDateChange}
              disabled={loading}
              allowClear={true}
            />
          </Col>
        )}
        <Col flex="auto">
          <div style={{ display: "flex", flexDirection: "row", gap: 8, justifyContent: "flex-end" }}>
            <Tooltip title="Limpiar todos los filtros">
              <Button
                danger
                onClick={limpiarFiltros}
                disabled={loading}
                icon={<ReloadOutlined />}
              >
                Limpiar
              </Button>
            </Tooltip>

            {permissionExport && (
              <ExportToExcel
                data={exportData}
                loading={loading}
              />
            )}
          </div>
        </Col>
      </Row>
      {(
        (isAdmin && (departamentoId || municipioId || promotoresId || (fechaInicio && fechaFin))) ||
        (isRol2 && (promotoresId || (fechaInicio && fechaFin)))
      ) && (
          <div style={{ marginTop: 12, fontSize: 12, color: '#666' }}>
            <span>Filtros activos: </span>
            {isAdmin && departamentoId && (
              <span style={tagStyle}>
                Depto: {departamentos.find(d => d.oid === departamentoId)?.departamento}
              </span>
            )}
            {isAdmin && municipioId && (
              <span style={tagStyle}>
                Munic: {municipios.find(m => m.oid === municipioId)?.municipio}
              </span>
            )}
            {(isAdmin || isRol2) && promotoresId && (
              <span style={tagStyle}>
                Promotor: {promotores.find(p => p.oid === promotoresId)
                  ? `${promotores.find(p => p.oid === promotoresId)?.nombres} ${promotores.find(p => p.oid === promotoresId)?.apellidos}`
                  : ''}
              </span>
            )}
            {(isAdmin || isRol2) && fechaInicio && fechaFin && (
              <span style={tagStyle}>
                {dayjs(fechaInicio).format('DD/MM/YY')} - {dayjs(fechaFin).format('DD/MM/YY')}
              </span>
            )}
          </div>
        )}
    </Card>
  );
}